import Vue from 'vue';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
import Bowser from 'bowser';
import { getViewData } from './view-data';

if (!getViewData('debug') && getViewData('env.RAVEN_PUBLIC_DSN')) {
    Raven
        .config(getViewData('env.RAVEN_PUBLIC_DSN'), {
            ignoreUrls: [
                // 3rd party scripts to exclude from logging
                new RegExp('https://embed.tawk.to/', 'i'),
                // Chrome extensions
                /extensions\//i,
                /^chrome:\/\//i,
                new RegExp('https://www.googletagmanager.com/', 'i'),
                new RegExp('https://www.gstatic.com/recaptcha', 'i'),
            ],
            ignoreErrors: [
                /Loading chunk .* failed/,
                /UET/,
                /fbq/,
                /_isMatchingDomain/,
            ],
            allowDuplicates: true,
            tags: {
                level: 'info',
                skip_slack: true,
            },
            shouldSendCallback(data) {
                if (!data || data.logger !== 'bookings') {
                    return true;
                }

                const event = { ...data, contexts: Bowser.parse(window.navigator.userAgent) };
                if (event.extra) {
                    event.context = event.extra;
                    delete event.extra;
                }

                Vue.http.post('/api/v2/sentry-events', event).catch(() => undefined);

                return true;
            },
        })
        .addPlugin(RavenVue, Vue)
        .install();
}
